import React from 'react';
import { motion } from 'framer-motion';
const pains = ['Sentís que dependés demasiado de un sueldo y que, si mañana algo cambia, no tenés otra fuente de ingreso que te respalde.', 'Querés tener más tiempo libre, pero tu rutina actual te consume y no te deja espacio para construir algo propio.', 'Ves a otras personas vendiendo online y te preguntás: “¿por qué yo no?”, pero no sabés por dónde empezar.', 'Tenés ganas de emprender, pero te abruma pensar en la tienda, los productos, los pagos, la publicidad y todo lo técnico.', 'No querés seguir esperando “el momento perfecto” mientras pasan los meses y seguís en el mismo lugar.', 'Querés un ingreso que no dependa únicamente de cambiar horas por dinero.', '¿Querés vivir de internet, pero ya te frustraste con cursos genéricos que no te funcionaron?'];
export function PainPoints() {
  return <section className="py-24 px-6 relative" data-id="element-39">
      <div className="max-w-5xl mx-auto" data-id="element-40">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold mb-16 text-center max-w-3xl mx-auto leading-tight" data-id="element-41">
          ¿Sentís que el tiempo pasa y seguís dejando tu idea para después?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-16" data-id="element-42">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className={`bg-brand-card p-6 rounded-2xl border border-brand-border ${i === pains.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-43">
              <p className="text-brand-text/80 text-lg" data-id="element-44">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-45">
          <p className="text-2xl md:text-3xl font-medium text-brand-goldLight" data-id="element-46">
            "No es tu culpa. El sistema tradicional está roto."
          </p>
          <p className="text-xl md:text-2xl font-bold" data-id="element-47">
            No necesitás más tiempo.{' '}
            <span className="gold-gradient-text" data-id="element-48">
              Necesitás dejar de perderlo improvisando.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}